<div class="main-content table-page mi-bsc">
  <div class="container-fluid">
    <nav class="bsc-migas" aria-label="Ruta de navegación">
      <a [routerLink]="ruta.tablero" [queryParams]="{ anio: anio }" *ngIf="verTablero; else sinTablero">BSC</a>
      <ng-template #sinTablero><span>BSC</span></ng-template>
      <span aria-hidden="true">›</span>
      <span aria-current="page">Mi BSC</span>
    </nav>

    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p *ngIf="teToca.length > 0">
          <ng-container *ngFor="let s of teToca; trackBy: trackSegmento">
            <strong *ngIf="s.fuerte; else normal">{{ s.texto }}</strong>
            <ng-template #normal>{{ s.texto }}</ng-template>
          </ng-container>
        </p>
        <p *ngIf="teToca.length === 0">
          Captura mensual de actividad y evidencia de los KPIs de tu área, y el cierre de cada trimestre.
        </p>
      </div>

      <div class="table-page__toolbar-actions mi-bsc__acciones">
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           *ngIf="verTablero && idBscArea != null && (estado === 'DATOS' || estado === 'SIN_AUTORIZAR')"
           [routerLink]="[ruta.area, idBscArea]" [queryParams]="queryArea">
          <span class="material-icons" aria-hidden="true">insights</span>
          Ver tablero del área
        </a>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           *ngIf="viaExcel && puedeCargarExcel && estado === 'DATOS'" [routerLink]="ruta.cargaExcel"
           [queryParams]="{ modo: 'AVANCES', anio: anio }">
          <span class="material-icons" aria-hidden="true">upload_file</span>
          Cargar Excel
        </a>
        <button type="button" mat-raised-button class="btn table-page__primary-btn"
                *ngIf="capturaHabilitada && mesTeToca != null" [disabled]="loading" (click)="capturarTeToca()">
          <span class="material-icons" aria-hidden="true">edit_calendar</span>
          Capturar {{ textoMes(mesTeToca) }}
        </button>
      </div>
    </section>

    <app-selector-corte-bsc prefijo="bsc-mi" [mostrarCorte]="false" [anio]="anioInicial" [deshabilitado]="loading"
                            (cambio)="onSeleccion($event)">
      <div meta class="tickets-filter mi-bsc__filtro-area" *ngIf="opcionesArea.length > 1">
        <label for="bsc-mi-area">Área</label>
        <div class="tickets-select">
          <mat-icon aria-hidden="true">groups</mat-icon>
          <select id="bsc-mi-area" [disabled]="loading" (change)="cambiaArea($event)">
            <option *ngFor="let a of opcionesArea" [value]="a.idBscArea" [selected]="a.idBscArea === idBscArea">
              {{ a.nombre }}
            </option>
          </select>
        </div>
      </div>
      <div meta class="tickets-toolbar__meta" *ngIf="estado === 'DATOS'">
        <span>{{ loading ? "Actualizando…" : resumenBarra }}</span>
        <strong>{{ textoVia }}</strong>
      </div>
    </app-selector-corte-bsc>

    <output class="bsc-franja" *ngIf="avisoArea">
      <span class="material-icons" aria-hidden="true">info</span>
      <span>{{ avisoArea }}</span>
    </output>

    <!-- Lo que se guardó en el cuadro de captura. La región existe siempre: así se anuncia al llegar. -->
    <output class="mi-bsc__guardado" aria-live="polite">
      <div class="bsc-franja mi-bsc__guardado-franja" *ngIf="mensajeGuardado">
        <span class="material-icons" aria-hidden="true">check_circle</span>
        <span>{{ mensajeGuardado }}</span>
      </div>
    </output>

    <!-- ============================ Estados sin datos ============================ -->
    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'CARGANDO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando tu BSC</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'ERROR'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar Mi BSC</h3>
        <p>{{ error }}</p>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          Volver a consultar
        </button>
      </div>
    </section>

    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'SIN_AREAS'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">groups</span>
        <h3>No estás asignado a ningún área del BSC</h3>
        <p>Calidad asigna a cada área su responsable y capturistas en Parámetros.</p>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeConfigurar"
           [routerLink]="ruta.parametros">
          <span class="material-icons" aria-hidden="true">tune</span>
          Ir a Parámetros
        </a>
      </div>
    </section>

    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'SIN_CICLO'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">event_busy</span>
        <h3>{{ anio }} todavía no está dado de alta en el BSC</h3>
        <p>Calidad lo abre en Parámetros (umbral, semáforo y fechas del ciclo); después se planean las metas.</p>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" *ngIf="puedeConfigurar"
           [routerLink]="ruta.parametros">
          <span class="material-icons" aria-hidden="true">tune</span>
          Configurar {{ anio }}
        </a>
      </div>
    </section>

    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'SIN_PLANEACION'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">event_note</span>
        <h3>{{ nombreArea || "Tu área" }} no tiene planeación {{ anio }}</h3>
        <p>Los avances se capturan sobre la planeación del año autorizada por Dirección.</p>
        <a mat-raised-button class="btn table-page__primary-btn" *ngIf="verPlaneacion && idBscArea != null"
           [routerLink]="ruta.planeacion" [queryParams]="queryPlaneacion">
          <span class="material-icons" aria-hidden="true">event_note</span>
          Ir a Planeación de metas
        </a>
      </div>
    </section>

    <section class="table-page__card mi-bsc__vacio" *ngIf="estado === 'SIN_AUTORIZAR'">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">pending_actions</span>
        <h3>La planeación {{ anio }} de {{ nombreArea }} todavía no está autorizada</h3>
        <p>{{ pasoPlaneacion?.detalle }}. Los avances se capturan cuando Dirección la autoriza.</p>
        <a mat-raised-button class="btn table-page__primary-btn" *ngIf="verPlaneacion && idBscArea != null"
           [routerLink]="ruta.planeacion" [queryParams]="queryPlaneacion">
          <span class="material-icons" aria-hidden="true">event_note</span>
          Ver la planeación
        </a>
      </div>
    </section>

    <!-- Avisos del servidor: un bloque que no se pudo leer, el histórico, la planeación sin autorizar… -->
    <section class="table-page__card bsc-bloque" *ngIf="avisos.length > 0 && estado !== 'CARGANDO' && estado !== 'ERROR'">
      <div class="bsc-mensajes bsc-mensajes--aviso">
        <h3>
          <span class="material-icons" aria-hidden="true">info</span>
          Para tomar en cuenta
        </h3>
        <ul>
          <li *ngFor="let a of avisos">{{ a }}</li>
        </ul>
      </div>
    </section>

    <!-- ============================ El año ============================ -->
    <ng-container *ngIf="estado === 'DATOS'">
      <section class="table-page__card mi-bsc__ciclo" aria-label="Ciclo del año">
        <div class="mi-bsc__paso mi-bsc__paso--fijo" *ngIf="pasoPlaneacion as p" [ngClass]="p.clase">
          <span class="mi-bsc__numero" aria-hidden="true">{{ p.numero }}</span>
          <span class="mi-bsc__paso-texto">
            <strong>{{ p.titulo }}</strong>
            <span>{{ p.detalle }}</span>
            <a class="table-page__link mi-bsc__paso-enlace" *ngIf="verPlaneacion" [routerLink]="ruta.planeacion"
               [queryParams]="queryPlaneacion">Ver planeación</a>
          </span>
        </div>

        <div class="mi-bsc__pestanas" role="tablist" aria-label="Trimestres del año">
          <button type="button" role="tab" class="mi-bsc__paso" *ngFor="let p of pasos; trackBy: trackPaso"
                  [id]="'mi-bsc-pestana-' + p.q" [ngClass]="p.clase" [class.is-elegido]="p.q === qElegido"
                  [attr.aria-selected]="p.q === qElegido" [attr.tabindex]="p.q === qElegido ? 0 : -1"
                  aria-controls="mi-bsc-trimestre" (click)="eligeQ(p.q ?? 1)" (keydown)="teclaPestana($event, p.q ?? 1)">
            <span class="mi-bsc__numero" aria-hidden="true">{{ p.numero }}</span>
            <span class="mi-bsc__paso-texto">
              <strong>{{ p.titulo }}<span class="bsc-oculto">, {{ p.estadoTexto }}</span></strong>
              <span>{{ p.detalle }}</span>
            </span>
          </button>
        </div>
      </section>

      <div class="mi-bsc__rejilla">
        <!-- ============================ Checklist del mes ============================ -->
        <section class="table-page__card mi-bsc__captura" id="mi-bsc-trimestre" role="tabpanel"
                 [attr.aria-labelledby]="'mi-bsc-pestana-' + qElegido">
          <header class="mi-bsc__encabezado">
            <div class="mi-bsc__encabezado-fila">
              <h2 id="mi-bsc-mes-titulo">{{ tituloMes }}</h2>
              <div class="mi-bsc__progreso">
                <span class="mi-bsc__barra" aria-hidden="true">
                  <span [style.width.%]="avanceMes"></span>
                </span>
                <progress class="cdk-visually-hidden" max="100" [value]="avanceMes"
                          aria-labelledby="mi-bsc-mes-titulo"></progress>
                <span>{{ limiteMes }}</span>
              </div>
            </div>

            <fieldset class="mi-bsc__meses" aria-label="Mes del trimestre">
              <button type="button" class="mi-bsc__mes-opcion" *ngFor="let m of opcionesMes; trackBy: trackMes"
                      [ngClass]="m.clase" [class.is-elegido]="m.mes === mesElegido"
                      [attr.aria-pressed]="m.mes === mesElegido" (click)="eligeMes(m.mes)">
                <span>{{ m.nombre }}</span>
                <small>{{ m.capturados }}/{{ m.vigentes }}</small>
              </button>
            </fieldset>
          </header>

          <output class="bsc-franja mi-bsc__regreso" *ngIf="regreso">
            <span class="material-icons" aria-hidden="true">undo</span>
            <span>{{ regreso }}</span>
          </output>
          <p class="bsc-nota mi-bsc__nota" *ngIf="notaMes">{{ notaMes }}</p>

          <ul class="mi-bsc__lista" *ngIf="renglones.length > 0; else sinKpis">
            <li class="mi-bsc__renglon" *ngFor="let r of renglones; trackBy: trackRenglon" [attr.data-kpi]="r.idEjercicioKpi"
                [class.is-hecho]="r.capturado" [class.is-pendiente]="!r.capturado && r.vigente && r.estado?.valor !== 'BLOQUEADO'"
                [class.is-na]="!r.vigente">
              <span class="mi-bsc__marca material-icons" aria-hidden="true">
                {{ r.capturado ? "check_circle" : r.estado?.icono || "radio_button_unchecked" }}
              </span>
              <span class="mi-bsc__kpi-texto">
                <strong>{{ r.objetivo }}</strong>
                <span class="mi-bsc__detalle" [ngClass]="r.estado?.clase">{{ r.detalle }}</span>
                <span class="mi-bsc__avance" *ngIf="r.avance">{{ r.avance }}</span>
              </span>
              <span class="mi-bsc__acciones-renglon">
                <button type="button" class="table-page__link mi-bsc__accion" *ngIf="r.capturable" [disabled]="loading"
                        (click)="capturar(r)" [attr.aria-label]="(r.capturado ? 'Editar ' : 'Capturar ') + textoMes(mesElegido) + ' de ' + r.objetivo">
                  {{ r.capturado ? "Editar" : "Capturar" }}
                </button>
                <a class="table-page__link" [routerLink]="[ruta.kpi, r.idEjercicioKpi]" [queryParams]="{ q: qElegido }"
                   [attr.aria-label]="'Ver la ficha de ' + r.objetivo">Ver</a>
              </span>
            </li>
          </ul>
          <ng-template #sinKpis>
            <div class="table-page__empty mi-bsc__sin-kpis">
              <span class="material-icons" aria-hidden="true">playlist_remove</span>
              <h3>La planeación no tiene KPIs activos</h3>
            </div>
          </ng-template>

          <footer class="mi-bsc__pie" *ngIf="cierre as c">
            <span>{{ c.texto }}</span>
            <a mat-raised-button class="btn table-page__primary-btn" *ngIf="c.boton && c.habilitado && ejercicio"
               [routerLink]="[ruta.cierre, ejercicio.idEjercicio, qElegido]">
              <span class="material-icons" aria-hidden="true">task_alt</span>
              {{ c.textoBoton }}
            </a>
            <button type="button" mat-raised-button class="btn table-page__primary-btn" *ngIf="c.boton && !c.habilitado"
                    disabled>
              <span class="material-icons" aria-hidden="true">task_alt</span>
              {{ c.textoBoton }}
            </button>
          </footer>
        </section>

        <aside class="mi-bsc__lateral">
          <!-- ============================ Fechas del trimestre ============================ -->
          <section class="table-page__card mi-bsc__fechas" aria-labelledby="mi-bsc-fechas-titulo">
            <h2 id="mi-bsc-fechas-titulo">Fechas de Q{{ qElegido }}</h2>
            <dl>
              <div *ngFor="let f of fechas; trackBy: trackFecha" [ngClass]="f.clase">
                <dt>{{ f.texto }}</dt>
                <dd>
                  <span class="material-icons" aria-hidden="true" *ngIf="f.icono">{{ f.icono }}</span>
                  <span>{{ f.fecha }}</span>
                  <span class="bsc-oculto" *ngIf="f.estado">, {{ f.estado }}</span>
                  <span class="mi-bsc__fecha-estado" *ngIf="f.estado" aria-hidden="true">{{ f.estado }}</span>
                </dd>
              </div>
            </dl>
            <p class="bsc-nota">{{ notaFechas }}</p>
          </section>

          <!-- ============================ Bitácora ============================ -->
          <section class="table-page__card mi-bsc__bitacora" aria-labelledby="mi-bsc-bitacora-titulo">
            <h2 id="mi-bsc-bitacora-titulo">Bitácora del área</h2>
            <ol *ngIf="movimientos.length > 0; else sinBitacora">
              <li *ngFor="let m of bitacoraVisible; trackBy: trackMovimiento">
                <time>{{ m.cuando }}</time>
                <span>
                  <strong>{{ m.accion }}</strong> · {{ m.quien }}
                  <span class="mi-bsc__bitacora-detalle" *ngIf="m.detalle">{{ m.detalle }}</span>
                </span>
              </li>
            </ol>
            <ng-template #sinBitacora>
              <p class="bsc-nota">Sin movimientos registrados en la planeación {{ anio }}.</p>
            </ng-template>
            <button type="button" class="table-page__link mi-bsc__mas" *ngIf="movimientos.length > bitacoraVisible.length"
                    (click)="verTodaBitacora = true">
              Ver toda la bitácora ({{ movimientos.length }})
            </button>
          </section>
        </aside>
      </div>
    </ng-container>
  </div>
</div>
